'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { ErrorModalContent } from '@app/_components/error/ErrorModalContent';
import { ErrorModalHeader } from '@app/_components/error/ErrorModalHeader';
import { UnauthenticatedErrorModalContent } from '@app/_components/error/UnauthenticatedErrorModalContent';
import { pattern } from '@endurancewarranty/lib';
import { cx, Modal } from '@endurancewarranty/ui';
import { useJotaiAtom } from '@lib/states/jotai/hooks';
import { errorAtom } from '@states/error/errorAtom';
import type { TErrorContext } from '@states/error/errorAtom';
import type { FC } from 'react';
const {
  match
} = pattern;
export const ErrorModal: FC = () => {
  const $ = _c(29);
  const [isOpen, setIsOpen] = useState(false);
  const [errors, setErrors] = useJotaiAtom(errorAtom);
  let modalStyle;
  let t0;
  if ($[0] !== errors) {
    const {
      isPaymentError,
      isBadRequestError,
      isUnauthenticatedError,
      isUnauthorizedError
    } = errors.reduce(_temp, {
      isPaymentError: false,
      isBadRequestError: false,
      isUnauthenticatedError: false,
      isUnauthorizedError: false
    });
    modalStyle = cx({
      "w-[800px]": !isPaymentError,
      "w-[600px]": isPaymentError
    }, "max-h-[600px]");
    t0 = match({
      isPaymentError,
      isUnauthenticatedError,
      isUnauthorizedError,
      isBadRequestError
    }).returnType().with({
      isPaymentError: true
    }, _temp2).with({
      isUnauthenticatedError: true
    }, _temp3).with({
      isUnauthorizedError: true
    }, _temp4).with({
      isBadRequestError: true
    }, _temp5).otherwise(_temp6);
    $[0] = errors;
    $[1] = modalStyle;
    $[2] = t0;
  } else {
    modalStyle = $[1];
    t0 = $[2];
  }
  const errorContext = t0;
  let t1;
  let t2;
  if ($[3] !== errors.length) {
    t1 = () => {
      if (errors.length > 0) {
        setIsOpen(true);
      }
    };
    t2 = [errors.length];
    $[3] = errors.length;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  if ($[6] !== setErrors) {
    t3 = () => {
      setErrors([]);
      setIsOpen(false);
    };
    $[6] = setErrors;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const onClose = t3;
  let t4;
  if ($[8] !== isOpen || $[9] !== onClose) {
    t4 = {
      isOpen,
      onClose,
      hasCloseButton: false,
      shouldCloseOnBlur: false
    };
    $[8] = isOpen;
    $[9] = onClose;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const sharedProps = t4;
  if (errorContext === "unauthenticated") {
    let t5;
    if ($[11] !== errorContext || $[12] !== onClose) {
      t5 = <ErrorModalHeader errorContext={errorContext} onClose={onClose} />;
      $[11] = errorContext;
      $[12] = onClose;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    let t6;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <div className="mt-14"><UnauthenticatedErrorModalContent /></div>;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    let t7;
    if ($[15] !== sharedProps || $[16] !== t5) {
      t7 = <Modal className="w-[400px]" {...sharedProps}>{t5}{t6}</Modal>;
      $[15] = sharedProps;
      $[16] = t5;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    return t7;
  }
  let t5;
  if ($[18] !== errorContext || $[19] !== onClose) {
    t5 = <ErrorModalHeader errorContext={errorContext} onClose={onClose} />;
    $[18] = errorContext;
    $[19] = onClose;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== errorContext || $[22] !== errors) {
    t6 = <ErrorModalContent className="mt-14" errorContext={errorContext} errors={errors} />;
    $[21] = errorContext;
    $[22] = errors;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== modalStyle || $[25] !== sharedProps || $[26] !== t5 || $[27] !== t6) {
    t7 = <Modal className={modalStyle} {...sharedProps}>{t5}{t6}</Modal>;
    $[24] = modalStyle;
    $[25] = sharedProps;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  return t7;
};
function _temp(prev, error) {
  let errorType = {};
  bb2: switch (error.context) {
    case "unauthenticated":
      {
        errorType = {
          isUnauthenticatedError: true
        };
        break bb2;
      }
    case "unauthorized":
      {
        errorType = {
          isUnauthorizedError: true
        };
        break bb2;
      }
    case "bad_request":
      {
        errorType = {
          isBadRequestError: true
        };
        break bb2;
      }
    case "payment":
      {
        errorType = {
          isPaymentError: true
        };
        break bb2;
      }
    case "default":
    default:
  }
  return {
    ...prev,
    ...errorType
  };
}
function _temp2() {
  return "payment";
}
function _temp3() {
  return "unauthenticated";
}
function _temp4() {
  return "unauthorized";
}
function _temp5() {
  return "bad_request";
}
function _temp6() {
  return "default";
}